import Vue from 'vue';
import VueRouter from 'vue-router';

import Policies from '@/core/policies';
import { authenticated, notCustomer } from './guards/authGuards';
import { authorized } from './guards/authorizationGuards';
import { go } from './guards/helpers';
import { backordersGuard } from './guards/redirectGuard';
import { MetaRoles, Roles } from '@/core/constants/roleConstants';

import HomeView from '../views/HomeView.vue';
import SignIn from '../views/auth/SignIn.vue';
import SignUp from '../views/auth/SignUp.vue';
import Logout from '@/views/auth/Logout.vue';
import PasswordReset from '../views/auth/PasswordReset.vue';
import ConfirmAccount from '../views/auth/ConfirmAccount.vue';
import RecoverPassword from '../views/auth/RecoverPassword.vue';
import ShoppingCart from '../views/shopping_cart/ShoppingCart.vue';
import ShoppingCartReminder from '../views/shopping_cart_reminder/ShoppingCartReminder.vue';
import ShoppingCartM from '../views/shopping_cart_reminder/ShoppingCartM.vue';
import HistoryOrders from '../views/history_orders/HistoryOrders.vue';
import HistoryRecords from '../views/history_records/HistoryRecords.vue';
import CustomerRegistration from '../views/client_request/CustomerRegistration.vue';
import CustomerUpdate from '../views/client_request/CustomerUpdate.vue';
import CustomerStatus from '../views/client_request/CustomerStatus.vue';
import FillRate from '../views/fill_rate/FillRate.vue';
import OpportunityMarket from '../views/opportunity_market/OpportunityMarket.vue';
import ContactCreate from '../views/contact/ContactCreate.vue';
import ContactList from '../views/contact/ContactList.vue';
import MultimediaCenter from '../views/multimedia_center/MultimediaCenter.vue';
import MultimediaCenterVideo from '../views/multimedia_center/MultimediaCenterVideo.vue';
import AccountStatus from '../views/account_status/AccountStatus.vue';
import Planeador from '../views/planeador/Planeador.vue';
import Forbidden from '../views/errors/403.vue';
import Manager from '../views/client_request/Manager.vue';
import ManagerRequest from '../views/client_request/ManagerRequest.vue';
import ManagerHome from '../views/daily/manager/ManagerHome.vue';
import Panelsol from '../views/iusasol/Panelsol.vue';
import QuoterCart from '../views/quoter_cart/QuoterCart.vue';
import NewQuoterCart from '../views/quoter_cart/NewQuoterCart.vue';
import NewQuoterCartEdit from '../views/quoter_cart/NewQuoterCartEdit.vue';
import QuoterHistory from '../views/quoter_cart/QuoterHistory.vue';
import QuoterCartEdit from '../views/quoter_cart/QuoterCartEdit.vue';
import QuoterCartShopping from '../views/quoter_cart/QuoterCartShopping.vue';
import Administrator from '../views/administrator/AdministratorHome.vue';
import Renglonaje from '../views/renglonaje/Renglonaje.vue';
import RenglonajeByCustomer from '../views/renglonaje_seller_manager/Renglonaje.vue';
import RenglonajeByFamily from '../views/renglonaje/RenglonajeDirector.vue';
import ShoppingCartPR from '../views/shopping_cart_pr/ShoppingCart.vue';
import ShoppingCartMPR from '../views/shopping_cart_reminder_pr/ShoppingCartMPR.vue';
import ShoppingCartReminderPR from '../views/shopping_cart_reminder_pr/ShoppingCartReminderPR.vue';
import QuoterCartShoppingPR from '../views/quoter_cart/QuoterCartShoppingPr.vue';
import ShoppingCartPopPr from '../views/shopping_cart_pr/ShoppingCartPop.vue';
import ShoppingCartPsmaPr from '../views/shopping_cart_pr/ShoppingCartPsma.vue';
import ShoppingCartPdrPr from '../views/shopping_cart_pr/ShoppingCartPdr.vue';
import ShoppingCartPsnwPr from '../views/shopping_cart_pr/ShoppingCartPsnw.vue';
import ShoppingCartPstn from '../views/shopping_cart/ShoppingCartPstn.vue';

import ShoppingCartPop from '../views/shopping_cart/ShoppingCartPop.vue';
import ShoppingCartPsma from '../views/shopping_cart/ShoppingCartPsma.vue';
import ShoppingCartPdr from '../views/shopping_cart/ShoppingCartPdr.vue';
import ShoppingCartPsnw from '../views/shopping_cart/ShoppingCartPsnw.vue';

//logistic reports
import logistics_reports from '../views/logistics_reports/index.vue';

//
import ClientGroup from '../views/client_group/ClientGroup.vue';
import store from '@/store';
import refundsRoutes from './refundsRoutes';
import administratorRoutes from './administratorRoutes';
import CustomerAccountStatement from '../views/customer_account_statement/Account_Statement';
import sellerRoutes from './sellerRoutes';
import directorRoutes from './directorRoutes';
import creditRoutes from './credit';
import weeklyEarningsRoutes from './weeklyEarnings';
import ReportStock from '../views/report_stock/ReportStock.vue';

import Briefcase from '../views/briefcase/Briefcase.vue';
import OrderStatus from '../views/order_status/OrderStatus.vue';
import OrderDetail from '../views/order_status/Detail.vue';
import PromissoryNotes from '@/views/client_request/promissory_notes/PromissoryNotes.vue';

import StructureHome from '@/views/structure_director_regional/StructureHome.vue';

import NewShoppingCart from '../views/shopping_cart_new/NewShoppingCart.vue';
import ProjectManager from '@/views/project_manager/ProjectManager.vue';
/** Test component  */
import testTimming from '../views/metrics/timming.vue';
import FrontMetrics from '../views/metrics/FrontMetrics.vue';
import SoapMetrics from '../views/metrics/SoapMetrics.vue';
/** Test component  */

import OCPendientes from '../views/order_merc/OCPendientes.vue';
import Vinculos from '../views/vinculos/Vinculos.vue';

import NewShoppingCartPR from '../views/shopping_cart_new/NewShoppingCartPR.vue';
import NewShoppingCartBackPR from '../views/shopping_cart_new/NewShoppingCartBackPR.vue';
import NewShoppingCartBack from '../views/shopping_cart_new/NewShoppingCartBack.vue';

/** Test component  */
import ChannelSelection from '../views/auth/ChannelSelectionView.vue';

import QuotationStatistics from '../views/statistics/QuotationStatistics.vue';
import CreateReelOrder from '../views/reel_order/CreateReelOrder.vue';
import CreateReelReminderOrder from '../views/reel_order/CreateReelReminderOrder.vue';
import CreateKitOrder from '../views/kit_order/CreateKitOrder.vue';

import ConsultasDT from '@/views/vinculos/ConsultasDT.vue';
import Notifications from '@/views/notifications/Notifications.vue';
import ResultsExpressSales from '../views/expressSales/ResultsExpressSales.vue';
import GeneralGroupDataCounters from '../views/general_group_data_counters/GeneralGroupDataCounters.vue';
import AdminPromotions from '@/views/promotions/AdminPromotions.vue';
// Public routes
import EmailValidated from '@/views/public/EmailValidated.vue';
import RenglonajeInvoicedAndNotInvoiced from '@/views/renglonaje/RenglonajeInvoicedAndNotInvoiced.vue';

// Rebate Detail
import RebateDetail from '../views/account_status/RebateDetail.vue';
import { Channels } from '@/core/constants/channelConstants';

Vue.use(VueRouter);

export const hasAnyRole = (storeroles, roles) => {
  return storeroles.some((role) => roles.includes(role.name));
};

export const hasAnyPermission = (storepermissions, permissions) => {
  return storepermissions.some((permission) =>
    permissions.includes(permission.name)
  );
};

const routes = [
  {
    path: '/',
    name: 'SignIn',
    component: SignIn,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        return next({
          name: 'Home',
        });
      }
      next();
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      next();
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: HomeView,
    meta: { role: 'Customer', redirectpermissions: ['pgc.redirect'] },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Seller'])) {
        return next({ name: 'SellerResults' });
      }
      if (
        hasAnyRole(store.getters['auth/roles'], [
          'Manager',
          'Submanager',
          'IELManager',
          'IELSubManager',
        ])
      ) {
        return next({ name: 'ManagerHome' });
      }
      if (
        hasAnyRole(store.getters['auth/roles'], [
          'Director',
          'IELDirector',
          'IELCommercialDT',
          'IELCommercialPR',
          'DirectorNoCommercial',
          'Superuser',
          'IELMarketing',
          Roles.POST_SALE,
        ])
      ) {
        return next({ name: 'DailyDirector' });
      }
      if (
        hasAnyRole(store.getters['auth/roles'], [
          'RegionalManager',
          'IELRegManager',
        ])
      ) {
        return next({ name: 'RGChannelSelection' });
      }
      if (hasAnyRole(store.getters['auth/roles'], [Roles.SUB_DIRECTOR])) {
        return next({ name: 'DirectorChannelSelection' });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Administrator'])) {
        return next({ name: 'Administrator' });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['IELLogistics'])) {
        return next({ name: 'logistics_reports' });
      }
      if (
        hasAnyRole(store.getters['auth/roles'], ['Credit', 'CreditAssistant'])
      ) {
        return next({ name: 'CreditIndex' });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['SellerPGC'])) {
        return next({ name: 'RequestsSeller' });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['ManagerPGC'])) {
        return next({ name: 'Manager' });
      }
      if (
        hasAnyRole(store.getters['auth/roles'], [
          'IELExpressSales',
          'IELBriefcase',
        ])
      ) {
        return next({ name: 'DirectorChannelSelection' });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['NotificationAdmin'])) {
        return next({ name: 'Notifications' });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['AdminPromotion'])) {
        return next({ name: 'AdminPromotions' });
      }

      if (hasAnyRole(store.getters['auth/roles'], [Roles.SCHEDULE])) {
        return next({ name: 'Schedule' });
      }

      if (hasAnyRole(store.getters['auth/roles'], [Roles.PRESIDENCY])) {
        return next({ name: 'DirectorChannelSelection' });
      }

      next();
    },
  },
  {
    //Caratula cliente desde el rol gerente y vendedor
    path: '/customer-cover',
    name: 'CustomerCover',
    component: HomeView,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (
        !hasAnyRole(store.getters['auth/roles'], [
          'Manager',
          'Seller',
          'Submanager',
          'IELManager',
          'IELSubManager',
        ])
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/customer-update',
    name: 'CustomerUpdate',
    component: CustomerUpdate,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/client-group/:opt?',
    name: 'ClientGroup',
    component: ClientGroup,
    meta: { role: 'Customer' },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/cartera',
    name: 'Briefcase',
    component: Briefcase,
    meta: { role: 'Seller' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/order-status/:opt?',
    name: 'OrderStatus',
    component: OrderStatus,
    meta: { role: 'Customer' },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/order-detail/:id',
    name: 'OrderDetail',
    component: OrderDetail,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/client-request',
    name: 'CustomerRegistration',
    component: CustomerRegistration,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (
        store.getters['auth/user'].request_status == 'Aceptada' ||
        store.getters['auth/user'].request_status == 'Rechazada'
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/customer-status',
    name: 'CustomerStatus',
    component: CustomerStatus,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      next();
    },
  },
  {
    path: '/account-status/:disc?',
    name: 'AccountStatus',
    component: AccountStatus,
    meta: { role: 'Customer' },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (
        hasAnyRole(store.getters['auth/roles'], [
          'Manager',
          'Submanager',
          'IELManager',
          'IELSubManager',
        ])
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-remider',
    name: 'ShoppingCartReminder',
    component: ShoppingCartReminder,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-m',
    name: 'ShoppingCartM',
    component: ShoppingCartM,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart',
    name: 'ShoppingCart',
    component: ShoppingCart,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  /*New shopping cart*/
  {
    path: '/shoppingcart/crear/:doctype/:idq',
    name: 'NewShoppingCart',
    component: NewShoppingCart,
    meta: {
      role: 'Customer',
      reload: true,
    },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  /*New shopping cart*/
  {
    path: '/history-orders',
    name: 'HistoryOrders',
    component: HistoryOrders,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/backorders-history',
    name: 'backorders',
    component: () => import('../views/reminders/History'),
    children: [
      {
        path: '',
        name: 'backordersCustomer',
        meta: { role: 'Customer' },
      },
      {
        path: 'manager',
        name: 'backordersHistoryManager',
        meta: {
          role: 'Manager',
          validateRole: true,
          roles: ['Customer', 'CustomerPR'],
        },
      },
      {
        path: 'seller',
        name: 'backordersHistorySeller',
        meta: {
          role: 'Seller',
          validateRole: true,
          roles: ['Customer', 'CustomerPR'],
        },
      },
      {
        path: 'regional',
        name: 'backordersHistoryRegional',
        meta: {
          role: 'Regional',
          validateRole: true,
          roles: ['Customer', 'CustomerPR'],
        },
      },
      {
        path: 'express',
        name: 'backordersHistory',
        meta: { validateRole: true, roles: ['Customer', 'CustomerPR'] },
      },
    ],
    beforeEnter: (to, from, next) => next(authenticated() || go()),
    redirect: () => {
      return backordersGuard();
    },
  },
  {
    path: '/carts-history',
    name: 'recentOrders',
    component: () => import('../views/history_orders/RecentOrdersHistory.vue'),
    meta: {
      role: 'Customer',
      validateRole: true,
      roles: ['Customer', 'CustomerPR'],
    },
    beforeEnter: (to, from, next) =>
      next(
        authenticated() || authorized(Policies.OrderPolicy.canList()) || go()
      ),
  },
  {
    path: '/history-records',
    name: 'HistoryRecords',
    component: HistoryRecords,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/quoter-history', //navBar usa esta url (actualizar ambas en caso dé)
    name: 'QuoterHistory',
    component: QuoterHistory,
    meta: { role: 'Customer' },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/iusasol/panel',
    name: 'Panelsol',
    component: Panelsol,
    meta: { role: 'Seller' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/quoter-cart',
    name: 'QuoterCart',
    component: QuoterCart,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/cotizacion/editar/:quoter_id/:document_type?',
    meta: { role: 'Customer' },
    name: 'NewQuoterCartEdit',
    component: NewQuoterCartEdit,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/cotizacion/crear',
    name: 'NewQuoterCart',
    meta: { role: 'Customer' },
    component: NewQuoterCart,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/quoter-cart-edit',
    name: 'QuoterCartEdit',
    component: QuoterCartEdit,
    meta: {
      role: 'Customer',
      reload: true,
    },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/quoter-cart-shopping',
    name: 'QuoterCartShopping',
    component: QuoterCartShopping,
    meta: {
      role: 'Customer',
      reload: true,
    },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/fill-rate',
    name: 'FillRate',
    component: FillRate,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/oportunidad-mercado',
    name: 'OpportunityMarket',
    component: OpportunityMarket,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/contact',
    name: 'ContactList',
    component: ContactList,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/contact-create',
    name: 'ContactCreate',
    component: ContactCreate,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/multimedia-center',
    name: 'MultimediaCenter',
    component: MultimediaCenter,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      next();
    },
  },
  {
    path: '/multimedia-video',
    name: 'MultimediaCenterVideo',
    component: MultimediaCenterVideo,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      next();
    },
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        return next({
          name: 'Home',
        });
      }
      next();
    },
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: PasswordReset,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        return next({
          name: 'Home',
        });
      }
      next();
    },
  },
  {
    path: '/confirm-account',
    name: 'ConfirmAccount',
    component: ConfirmAccount,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        return next({
          name: 'Home',
        });
      }
      next();
    },
  },
  {
    path: '/recover-password/',
    name: 'RecoverPassword',
    component: RecoverPassword,
    beforeEnter: (to, from, next) => {
      if (store.getters['auth/authenticated']) {
        return next({
          name: 'Home',
        });
      }
      next();
    },
  },
  {
    path: '/planeador',
    component: { render: (h) => h('router-view') },
    children: [
      {
        path: 'seller',
        name: 'PlaneadorSeller',
        component: Planeador,
        meta: { role: 'Seller' },
      },
      {
        path: 'manager',
        name: 'PlaneadorManager',
        component: Planeador,
        meta: { role: 'Manager' },
      },
    ],
    beforeEnter: (to, from, next) =>
      next(authenticated() || notCustomer() || go()),
  },
  {
    path: '/agenda',
    name: 'Schedule',
    component: { render: (h) => h('router-view') },
    redirect: { name: 'ScheduleCalendar' },
    children: [
      {
        path: 'calendario',
        name: 'ScheduleCalendar',
        component: () => import('@/views/schedule/CalendarView.vue'),
      },
      {
        path: 'metricas',
        name: 'ScheduleMetrics',
        component: () => import('@/views/schedule/MetricsView.vue'),
      },
    ],
    beforeEnter: (to, from, next) =>
      next(
        authenticated() || authorized(Policies.SchedulePolicy.canList()) || go()
      ),
  },
  {
    path: '/registration-request/',
    component: Manager,
    children: [
      { path: 'manager', name: 'RequestManager', meta: { role: 'Manager' } },
      { path: 'regional', name: 'RequestRegional', meta: { role: 'Regional' } },
    ],
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    path: '/administrator',
    name: 'Administrator',
    component: Administrator,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (!hasAnyRole(store.getters['auth/roles'], ['Administrator'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/manager/requests/:id',
    name: 'ManagerRequest',
    component: ManagerRequest,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    //Se cambia a seller
    path: '/manager/home',
    name: 'ManagerHome',
    component: ManagerHome,
    meta: { role: 'Manager' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (
        hasAnyRole(store.getters['auth/roles'], [
          'Customer',
          'CustomerPR',
          'Seller',
        ])
      ) {
        return next({ name: '403' });
      }
      next();
    },
  },
  {
    path: '/renglonaje-by-family',
    component: RenglonajeByFamily,
    children: [
      {
        path: 'director',
        name: 'RenglonajeByFamilyDirector',
        meta: { role: 'Director' },
      },
      {
        path: 'regional',
        name: 'RenglonajeByFamilyRegional',
        meta: { role: 'Regional' },
      },
      {
        path: 'manager',
        name: 'RenglonajeByFamilyManager',
        meta: { role: 'Manager' },
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (!store.getters['auth/authenticatedDirector']) {
        return next({
          name: 'DirectorChannelSelection',
        });
      }
      if (
        hasAnyRole(store.getters['auth/roles'], [
          'Customer',
          'CustomerPR',
          'Seller',
        ])
      ) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    path: '/renglonaje/sales',
    component: RenglonajeInvoicedAndNotInvoiced,
    children: [
      {
        path: 'seller/:status',
        name: 'InvoicedAndNotInvoicedSeller',
        meta: { role: 'Seller' },
        props: true,
      },
      {
        path: 'manager/:status',
        name: 'InvoicedAndNotInvoicedManager',
        meta: { role: 'Manager' },
        props: true,
      },
      {
        path: 'regional/:status',
        name: 'InvoicedAndNotInvoicedRegional',
        meta: { role: 'Regional' },
        props: true,
      },
      {
        path: 'director/:status',
        name: 'InvoicedAndNotInvoicedDirector',
        meta: { role: 'Director' },
        props: true,
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (
        hasAnyRole(store.getters['auth/roles'], [
          'Guest',
          'Customer',
          'CustomerPR',
        ])
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/renglonaje/:view/:trim/:year',
    name: 'Renglonaje',
    component: Renglonaje,
    meta: { role: 'Customer' },
    props: true,
    beforeEnter: (to, from, next) => {
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    path: '/renglonaje-by-customer',
    component: RenglonajeByCustomer,
    children: [
      {
        path: 'seller',
        name: 'RenglonajeByCustomerSeller',
        meta: { role: 'Seller' },
      },
      {
        path: 'manager',
        name: 'RenglonajeByCustomerManager',
        meta: { role: 'Manager' },
      },
      {
        path: 'regional',
        name: 'RenglonajeByCustomerRegional',
        meta: { role: 'Regional' },
      },
    ],
    beforeEnter: (to, from, next) => {
      if (hasAnyRole(store.getters['auth/roles'], ['CustomerPR', 'Customer'])) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-pr',
    name: 'ShoppingCartPR',
    component: ShoppingCartPR,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-m-pr',
    name: 'ShoppingCartMPR',
    component: ShoppingCartMPR,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-remider-pr/:order',
    name: 'ShoppingCartReminderPR',
    component: ShoppingCartReminderPR,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/quoter-cart-shopping-pr',
    name: 'QuoterCartShoppingPR',
    component: QuoterCartShoppingPR,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-pop',
    name: 'ShoppingCartPop',
    component: ShoppingCartPop,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-psma',
    name: 'ShoppingCartPsma',
    component: ShoppingCartPsma,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-pdr',
    name: 'ShoppingCartPdr',
    component: ShoppingCartPdr,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-psnw',
    name: 'ShoppingCartPsnw',
    component: ShoppingCartPsnw,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-pstn',
    name: 'ShoppingCartPstn',
    component: ShoppingCartPstn,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-pop-pr',
    name: 'ShoppingCartPopPr',
    component: ShoppingCartPopPr,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-psma-pr',
    name: 'ShoppingCartPsmaPr',
    component: ShoppingCartPsmaPr,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-pdr-pr',
    name: 'ShoppingCartPdrPr',
    component: ShoppingCartPdrPr,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/report-stock',
    name: 'ReportStock',
    component: ReportStock,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-psnw-pr',
    name: 'ShoppingCartPsnwPr',
    component: ShoppingCartPsnwPr,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/shopping-cart-pstn',
    name: 'ShoppingCartPstn',
    component: ShoppingCartPstn,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/customer-account-statement/:opt?',
    name: 'CustomerAccountStatement',
    component: CustomerAccountStatement,
    meta: { role: 'Customer' },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      } /*
      if (hasAnyRole(store.getters["auth/roles"], ["Seller","Manager"])) {
        if (!store.getters['auth/customerData'] ) {
          return next({
            name: "Home",
          });
        }
      } */
      next();
    },
  },
  {
    path: '/pagares',
    name: 'PromissoryNotes',
    component: PromissoryNotes,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    path: '/ordenPedidoPendiente',
    name: 'OCPendientes',
    component: OCPendientes,
    meta: { role: 'Seller' },

    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/vinculos',
    component: Vinculos,
    children: [
      {
        path: 'director',
        name: 'VinculosDirector',
        meta: { role: 'Director' },
      },
      {
        path: 'regional',
        name: 'VinculosRegional',
        meta: { role: 'Regional' },
      },
      { path: 'manager', name: 'VinculosManager', meta: { role: 'Manager' } },
      { path: 'seller', name: 'VinculosSeller', meta: { role: 'Seller' } },
    ],
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      next();
    },
  },
  {
    path: '/test-timming',
    name: 'test-timming',
    component: testTimming,
  },
  {
    path: '/metrics/front',
    name: 'metrics-front',
    component: FrontMetrics,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      next();
    },
  },
  {
    path: '/metrics/soap',
    name: 'metrics-backend',
    component: SoapMetrics,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      next();
    },
  },
  {
    path: '/channel-selection',
    name: 'DirectorChannelSelection',
    component: ChannelSelection,
    meta: { role: 'Director' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }

      if (
        !hasAnyRole(store.getters['auth/roles'], [
          Roles.DIRECTOR,
          Roles.SUB_DIRECTOR,
          Roles.EXPRESS_SALES,
          Roles.BRIEFCASE,
          Roles.DIRECTOR_NON_COMMERCIAL,
          Roles.CREDIT_COLLECTIONS,
          Roles.CREDIT_ASSISTANT,
          Roles.SUPER_USER,
          Roles.MARKETING,
          Roles.POST_SALE,
          Roles.PRESIDENCY,
        ])
      ) {
        return next({ name: 'SignIn' });
      }

      next();
    },
  },
  /*New shopping cart*/
  {
    path: '/shoppingcart-pr/crear/:doctype/:idq',
    name: 'NewShoppingCartPR',
    component: NewShoppingCartPR,
    meta: {
      role: 'Customer',
      reload: true,
    },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  /*New shopping cart*/
  {
    path: '/presupuesto-estadistica',
    name: 'QuotationStatistics',
    component: QuotationStatistics,
    meta: { role: 'Seller' },

    beforeEnter: async (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      } else if (
        hasAnyRole(store.getters['auth/roles'], ['Customer', 'CustomerPR'])
      ) {
        return next({ name: '403' });
      }
      next();
    },
  },
  {
    path: '/backorder-reel',
    name: 'CreateReelOrder',
    component: CreateReelOrder,
    meta: { role: 'Customer' },

    beforeEnter: async (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      } else if (
        !hasAnyRole(store.getters['auth/roles'], [
          'CustomerPR',
          'Customer',
          'Seller',
          'Manager',
          'Submanager',
          'RegionalManager',
          'IELExpressSales',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
          'Superuser',
          'IELMarketing',
          Roles.POST_SALE,
        ])
      ) {
        return next({ name: '403' });
      }
      next();
    },
  },
  {
    path: '/backorder-reel-reminder',
    name: 'CreateReelReminderOrder',
    component: CreateReelReminderOrder,
    meta: { role: 'Customer' },

    beforeEnter: async (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      } else if (
        !hasAnyRole(store.getters['auth/roles'], [
          'CustomerPR',
          'Customer',
          'Seller',
          'Manager',
          'Submanager',
          'RegionalManager',
          'IELExpressSales',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
          'Superuser',
          'IELMarketing',
          Roles.POST_SALE,
        ])
      ) {
        return next({ name: '403' });
      }
      next();
    },
  },
  {
    path: '/combo-order',
    name: 'CreateKitOrder',
    component: CreateKitOrder,
    meta: { role: 'Customer' },

    beforeEnter: async (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      } else if (
        !hasAnyRole(store.getters['auth/roles'], [
          'CustomerPR',
          'Customer',
          'Seller',
          'Manager',
          'Submanager',
          'RegionalManager',
          'IELExpressSales',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
          'Superuser',
          'IELMarketing',
          Roles.POST_SALE,
        ])
      ) {
        return next({ name: '403' });
      }
      next();
    },
  },
  {
    path: '/structure-director',
    name: 'StructureDirector',
    component: StructureHome,
    meta: { role: 'Director' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (!store.getters['auth/authenticatedDirector']) {
        return next({
          name: 'DirectorChannelSelection',
        });
      }
      if (
        !hasAnyRole(store.getters['auth/roles'], [
          'Director',
          'IELDirector',
          'IELCommercialPR',
          'IELCommercialDT',
          'Subdirector',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
          'Superuser',
          'IELMarketing',
          Roles.POST_SALE,
        ])
      ) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    path: '/structure-regional-manager',
    name: 'StructureRegionalManager',
    component: StructureHome,
    meta: { role: 'Regional' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (
        !hasAnyRole(store.getters['auth/roles'], [
          'Director',
          'IELDirector',
          'IELCommercialPR',
          'IELCommercialDT',
          'Subdirector',
          'RegionalManager',
          'IELRegManager',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
          'Superuser',
          'IELMarketing',
          Roles.POST_SALE,
        ])
      ) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    path: '/consultasDT',
    name: 'ConsultasDT',
    meta: { role: 'Seller' },
    component: ConsultasDT,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  //logistics-reports
  {
    path: '/logistics-reports',
    name: 'logistics_reports',
    component: logistics_reports,
    meta: { role: 'IELLogistics' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }

      if (!hasAnyRole(store.getters['auth/roles'], ['IELLogistics'])) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  /*New shopping cart*/
  {
    path: '/shoppingcart-pr-bk/crear/:doctype/:idb/:type',
    name: 'NewShoppingCartBackPR',
    component: NewShoppingCartBackPR,
    meta: {
      role: 'Customer',
      reload: true,
    },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  /*New shopping cart*/
  {
    path: '/shoppingcart-bk/crear/:doctype/:idb/:type',
    name: 'NewShoppingCartBack',
    component: NewShoppingCartBack,
    meta: {
      role: 'Customer',
      reload: true,
    },
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/request-for-quotation',
    name: 'CreateRequestForQuotation',
    component: () =>
      import('../views/request_for_quotation/CreateRequestForQuotation'),
    meta: { role: 'Customer' },

    beforeEnter: async (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      } else if (
        !hasAnyRole(store.getters['auth/roles'], [
          'CustomerPR',
          'Customer',
          'Seller',
          'Manager',
          'Submanager',
          'RegionalManager',
          'IELExpressSales',
          Roles.POST_SALE,
        ])
      ) {
        return next({ name: '403' });
      }
      next();
    },
  },
  {
    path: '/create-notification',
    name: 'Notifications',
    component: Notifications,
    meta: { role: 'NotificationAdmin' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({
          name: 'SignIn',
        });
      }
      if (hasAnyRole(store.getters['auth/roles'], ['Guest'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/request-for-quotation/tracking',
    name: 'QuotationTracking',
    component: () => import('../views/request_for_quotation/HistoryTracking'),
    meta: { role: 'Customer' },

    beforeEnter: async (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      } else if (
        !hasAnyRole(store.getters['auth/roles'], [
          'CustomerPR',
          'Customer',
          'Seller',
        ])
      ) {
        return next({ name: '403' });
      }
      next();
    },
  },
  {
    path: '/results-express-sales',
    name: 'ResultsExpressSales',
    component: ResultsExpressSales,
    meta: { role: 'ExpressSales', reload: true },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (!store.getters['auth/authenticatedDirector']) {
        return next({
          name: 'DirectorChannelSelection',
        });
      }
      if (
        !hasAnyRole(store.getters['auth/roles'], [
          'IELExpressSales',
          'IELBriefcase',
          'CreditAssistant',
          'Credit',
        ])
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/results-express-sales',
    name: 'ResultsExpressSalesPR',
    component: ResultsExpressSales,
    meta: { role: 'ExpressSales', reload: true },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (!store.getters['auth/authenticatedDirector']) {
        return next({
          name: 'DirectorChannelSelection',
        });
      }
      if (
        !hasAnyRole(store.getters['auth/roles'], [
          'IELExpressSales',
          'IELBriefcase',
          'CreditAssistant',
          'Credit',
        ])
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/general-group-data-counters-director',
    name: 'GeneralGroupDataCountersDirector',
    component: GeneralGroupDataCounters,
    meta: { role: 'Director' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (!store.getters['auth/authenticatedDirector']) {
        return next({
          name: 'DirectorChannelSelection',
        });
      }
      if (
        !hasAnyRole(store.getters['auth/roles'], [
          'Director',
          'Subdirector',
          'IELDirector',
          'IELCommercialPR',
          'IELCommercialDT',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
          'Superuser',
          'IELMarketing',
          Roles.POST_SALE,
        ])
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/general-group-data-counters-regional',
    name: 'GeneralGroupDataCountersRegional',
    component: GeneralGroupDataCounters,
    meta: { role: 'Regional' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (
        !hasAnyRole(store.getters['auth/roles'], [
          'Director',
          'Subdirector',
          'IELDirector',
          'IELCommercialPR',
          'IELCommercialDT',
          'RegionalManager',
          'IELRegManager',
          'DirectorNoCommercial',
          'SubDirectorPRNoCommercial',
          'SubDirectorDTNoCommercial',
          'Superuser',
          'IELMarketing',
          Roles.POST_SALE,
        ])
      ) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/admin-promotions',
    name: 'AdminPromotions',
    component: AdminPromotions,
    meta: { role: 'Promotion' },
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      if (!hasAnyRole(store.getters['auth/roles'], ['AdminPromotion'])) {
        return next({
          name: '403',
        });
      }
      next();
    },
  },
  {
    path: '/rebate-detail/:quarter?',
    name: 'RebateDetail',
    component: RebateDetail,
    meta: { role: 'Customer' },
    beforeEnter: (to, from, next) => next(authenticated() || go()),
  },
  {
    path: '/email-validated',
    name: 'EmailValidated',
    component: EmailValidated,
  },
  {
    path: '/403',
    name: '403',
    component: Forbidden,
  },
  {
    path: '/project-manager',
    component: ProjectManager,
    children: [
      {
        path: 'manager',
        name: 'ProjectManager',
        meta: { role: MetaRoles[Roles.MANAGER] },
      },
      {
        path: 'regional',
        name: 'ProjectRegional',
        meta: { role: MetaRoles[Roles.REGIONAL_MANAGER] },
      },
      {
        path: 'director',
        name: 'ProjectDirector',
        meta: { role: MetaRoles[Roles.DIRECTOR] },
      },
    ],
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
  {
    path: '/invitacion/responder',
    name: 'InvitationRespond',
    component: () => import('@/views/public/InvitationRespond.vue'),
    meta: { public: true },
  },
  {
    path: '/visor',
    name: 'Visor',
    component: () => import('@/views/visor/VisorView.vue'),
    beforeEnter: (to, from, next) =>
      next(
        authenticated() || authorized(Policies.VisorPolicy.canList()) || go()
      ),
  },
];

const routeNotFound = [
  {
    path: '/:pathMatch(.*)*',
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/authenticated']) {
        return next({ name: 'SignIn' });
      }
      next();
    },
  },
];

const Allroutes = routes.concat(
  refundsRoutes,
  administratorRoutes,
  sellerRoutes,
  creditRoutes,
  directorRoutes,
  weeklyEarningsRoutes,
  routeNotFound
); //siempre poner routeNotFound al final

const router = new VueRouter({
  mode: 'history',
  //mode: "history",
  base: process.env.BASE_URL,
  routes: Allroutes,
});

router.beforeEach((to, from, next) => {
  const channel = store.getters['auth/user']?.VTWEG;

  const SCHEDULE_ONLY_CHANNELS = [
    Channels.EXPORT,
    Channels.INDUSTRIAL,
    Channels.MODERN,
    Channels.PROJECT,
    Channels.ECOMMERCE,
  ];

  const isScheduleOnly = SCHEDULE_ONLY_CHANNELS.includes(channel);

  if (isScheduleOnly) {
    const allowedRoutes = [
      'Schedule',
      'ScheduleCalendar',
      'ScheduleMetrics',
      'PasswordReset',
      'InvitationRespond',
      'SignIn',
      'Logout',
      '403',
      'DirectorChannelSelection',
      'RGChannelSelection',
    ];

    if (!allowedRoutes.includes(to.name)) {
      return next({ name: 'Schedule' });
    }
  }

  if (
    to.meta.redirectpermissions &&
    hasAnyPermission(
      store.getters['auth/permissions'],
      to.meta.redirectpermissions
    )
  ) {
    return next({ name: 'RequestsSeller' });
  }

  store.dispatch('cancellableRequest/abortRequests');
  next();
});

export default router;
